module.exports = __webpack_public_path__ + "static/media/HOME-image-map-opacity.c2d3173d.png";